module.exports = __webpack_public_path__ + "920e685e3530d37317dac7e1983cf53a.pdf";